/**
 * @file createContext
 * @author yuzong(yuzong@tencent.com)
 */
import React from 'react';
import { pascalCase } from '@tencent/glue-util-helper';
export function createContext() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var displayName = arguments.length > 1 ? arguments[1] : undefined;
  var Context = React.createContext(defaultValue);
  Context.displayName = displayName;
  var display = pascalCase(displayName || 'Context');

  function useContext() {
    var context = React.useContext(Context);

    if (context == null) {
      throw new Error("use".concat(display, "Instance must be used under <").concat(display, "Provider>"));
    }

    return context;
  }

  return [Context.Provider, useContext];
}